import React from 'react'

function Logo({ logo }) {
  return (
    <div className="logo" style={{}} >
      <img style={{ height: '100px', width: '200px', }} src={logo} alt="logo" />
    </div>
  )
}

export default Logo